var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CButton',{class:`${
    _vm.size === 'sm' ? 'd-flex align-items-center' : 'mz-button v2-mz-btn'
  }`,attrs:{"color":"primary","to":_vm.to,"size":_vm.size}},[_vm._v(" "+_vm._s(_vm.$t('Add'))+" "),_c('i',{staticClass:"ml-2 mz-icon icon-add",class:{ 'w-100 h-100': _vm.size === 'sm' }})])
}
var staticRenderFns = []

export { render, staticRenderFns }